import * as React from "react";
export abstract class AsyncReactComponent<TProps, TState> extends React.Component<TProps, TState>{
    setStateAsync<K extends keyof TState>(state: ((prevState: Readonly<TState>, props: Readonly<TProps>) => (Pick<TState, K> | TState | null)) | (Pick<TState, K> | TState | null)) {
        return new Promise((resolve) => {
            this.setState(state, ()=>{resolve(null);})
        });
    }
    delay(ms: number): Promise<void> {
        return new Promise<void>(function (resolve) {
            setTimeout(resolve, ms);
        });
    }
}
